// extracted by mini-css-extract-plugin
module.exports = {"root":"Admissions-module__root___1RgQu"};